import $ from 'jquery';

export function LayoutPreviewDirective($timeout) {
  'ngInject';

  return {
    restrict: 'E',
    scope: {
      layoutDef: '=',
      onselect: '&'
    },
    template: '<div class="preview-stage"></div><div class="preview-title">{{ title }}</div>',
    link: function (scope, element) {
      let maxW = 215, maxH = 200, scaleW = 1, scaleH = 1, scalingFactor = 1, padding = 11;
      let layout = scope.layoutDef;
      scope.title = layout.name;
      let masks = layout.masks;
      let stage = $(element).find('div.preview-stage');
      element.on('click', function () {
        scope.onselect({ id: layout.id });
      });

      if (layout.dimensions.width > maxW)
        scaleW = maxW / layout.dimensions.width;

      if (layout.dimensions.height > maxH)
        scaleH = maxH / layout.dimensions.height;

      scalingFactor = (scaleW < scaleH) ? scaleW : scaleH;
      let stageW = layout.dimensions.width * scalingFactor + 1;
      let stageH = layout.dimensions.height * scalingFactor + 1;
      stage.css('width', (stageW - padding) + 'px');
      stage.css('height', (stageH - padding) + 'px');

      if (scaleW < scaleH)
        stage.css('top', ((maxH - stageH) / 2 + padding / 2) + 'px');
      else
        stage.css('left', ((maxW - stageW) / 2 + padding / 2) + 'px');

      for (let i = 0; i < masks.length; i++) {
        let mask = masks[i];
        let imagePreview = document.createElement("div");
        imagePreview.className = 'img-preview';
        imagePreview.style.width = Math.max(1, Math.round(mask.dimensions.width * scalingFactor - padding - 1)) + 'px';
        imagePreview.style.height = Math.max(1, Math.round(mask.dimensions.height * scalingFactor - padding - 1)) + 'px';
        imagePreview.style.top = Math.max(1, Math.round(mask.position.x * scalingFactor - padding / 2)) + 'px';
        imagePreview.style.left = Math.max(1, Math.round(mask.position.y * scalingFactor - padding / 2)) + 'px';

        if (mask.rotation) {
          let rotateValue = 'rotate(' + mask.rotation + 'deg)';

          imagePreview.style.webkitTransform = rotateValue;
          imagePreview.style.mozTransform = rotateValue;
          imagePreview.style.msTransform = rotateValue;
          imagePreview.style.oTransform = rotateValue;
          imagePreview.style.transform = rotateValue;
        }

        $(imagePreview).append('<span class="index">' + mask.photoId + '</span>');

        stage.append(imagePreview);
      }
    }
  };
}



// WEBPACK FOOTER //
// ./client/components/canvas/layoutPreview.directive.js